export const logError = (message: string, error?: unknown) => {
    if (process.env.NODE_ENV === "production") return;
    if (error !== undefined) {
        // eslint-disable-next-line no-console
        console.error(message, error);
        return;
    }
    // eslint-disable-next-line no-console
    console.error(message);
};
